<template>
    <!-- 86bcfa7n0: Experian Authentication inside the report's steps, the same
         check as /rentrisk-verification (Rich: "so they do not have to go
         somewhere else and can stay within the flow"). -->
    <report-layout
        :report="report"
        :identity-verified="identity_verified"
        current-step="verify_identity"
    >
        <identity-form
            :states="states"
            :attempt="attempt"
            submit-route="reports.verify-identity.store"
            :submit-params="report.id"
            :cancel-href="route('reports.dashboard', report.id)"
            intro-text="Please read the following points before verifying your identity."
        />
    </report-layout>
</template>

<script>
import ReportLayout from './ReportLayout.vue'
import IdentityForm from '@/Components/ExperianVerification/IdentityForm.vue'

export default {
    components: {
        ReportLayout,
        IdentityForm,
    },
    props: {
        report: Object,
        states: Object,
        attempt: Object,
        identity_verified: { type: Boolean, default: false },
    },
}
</script>
